const custEslCheck = {
    path: 'custEslCheck',
    name: 'custEslCheck',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'eslCheck',
        icon: 'HSIconfont hs-icon-complete',
        showRealm: ['SYSTEM', 'ADMIN']
    },
    children: [
        {
            path: 'custStoreCheck',
            name: 'custStoreCheck',
            component: () => import('@/views/custStoreCheck'),
            meta: { code: 'eslCheck:storeCheck' }

        },
        {
            path: 'custSystemSearch',
            name: 'custSystemSearch',
            component: () => import('@/views/custSystemSearch'),
            meta: { code: 'eslCheck:eslSystemSearch' }

        }
    ]
};

export default custEslCheck;
